import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { StoreKeys } from './store-key.model';

export class StoreKeyDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return StoreKeys.fromDto(dto) as any;
  }
}
